import { memo, useEffect } from "react";

const FooterAd = () => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }, []);
  return (
    <div className="footer-ad">
      <ins
        className="adsbygoogle"
        style={{ display: "block", marginTop: "12px" }}
        data-ad-client="ca-pub-7062721784935312"
        data-ad-slot="3339111566"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default memo(FooterAd);
